import { t } from "@/lib/content";
import { buildServiceHref, isRoutableServiceTag } from "@/lib/i18n/paths";
import { toSiteLocale } from "@/lib/i18n/config";
import { SERVICE_ROUTES as services } from "@/lib/i18n/routing-catalog";
import type { NavServiceItem } from "@/lib/services";
import type { Lang } from "@/lib/types";

export function getNavServiceItems(lang: Lang): NavServiceItem[] {
  const locale = toSiteLocale(lang);
  return services
    .filter((service) => service.display?.nav !== false)
    .filter((service) => isRoutableServiceTag(service.tag))
    .map((service) => ({
      tag: service.tag,
      label: service.navigationTitle?.[locale as keyof typeof service.navigationTitle] ?? t(service.title, lang),
      href: buildServiceHref(locale, service.tag),
      description: t(service.shortDescription, lang),
    }));
}

